import {useEffect, useState} from 'react';

const getRootElement = () => {
    const element = document.getElementById('application');
    if (!element) {
        console.warn(`Not #application element in DOM`);
        return document.body;
    }
    return element;
};

export const useRootElement = () => {
    const [rootElement, setRootElement] = useState(getRootElement);

    useEffect(() => {
        if (rootElement !== document.body) {
            return;
        }
        const element = getRootElement();
        if (element !== rootElement) {
            setRootElement(element);
        }
    }, [rootElement]);

    return rootElement;
};
